import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errorCode } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/lib/i18n";
import { LogoMark } from "@/components/layout/Logo";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const { t, tErr } = useLang();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data } });
      } catch (e) {
        toast.error(tErr(errorCode(e)));
        setUser(false);
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser, tErr]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-paper" data-testid="auth-callback">
      <LogoMark className="h-12 w-12 animate-pulse" />
      <p className="text-sm text-navy/70">{t("auth.signingIn")}</p>
    </div>
  );
}
